import DeprecatedThemeOptions from './ThemeOptions';

const reducers = {
  DeprecatedThemeOptions
}

export default reducers